import countryLocales from 'i18n-iso-countries/langs/fr.json';
import countries      from 'i18n-iso-countries';

countries.registerLocale(countryLocales);

export type CountryCode = string | number | countries.Alpha2Code | countries.Alpha3Code

export const AllCountries = countries.getNames('fr', { select: 'official' });

export const getCountryName = code => countries.getName(code, 'fr', { select: 'official' });